import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

const FIELD_LABELS = { email: "Email", phone: "Phone", name: "Name", address: "Address", year: "Year", make: "Make", model: "Model" };

// Normalise FastAPI validation errors (arrays of objects) into a plain readable string
api.interceptors.response.use(undefined, (error) => {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) {
    error.response.data.detail = detail
      .map((d) => {
        const field = FIELD_LABELS[d?.loc?.[d.loc.length - 1]] || d?.loc?.slice(1).join(".") || "Input";
        const msg = String(d?.msg || "is invalid").replace(/^value error, /i, "");
        return `${field}: ${msg}`;
      })
      .join(" · ");
  } else if (detail && typeof detail === "object") {
    error.response.data.detail = detail.message || detail.msg || JSON.stringify(detail);
  }
  return Promise.reject(error);
});

export const photoUrl = (id) => `${API}/photos/${id}`;
